import { render } from "./home_two_columns.vue?vue&type=template&id=38aba8f0"
import script from "./home_two_columns.vue?vue&type=script&lang=js"
export * from "./home_two_columns.vue?vue&type=script&lang=js"

import "./home_two_columns.vue?vue&type=style&index=0&id=38aba8f0&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__